import { UserStatus } from '@bp/bp-graphql-types';
import { ProfileRoles } from '@bp/pim-auth-constants';
import { Dropdown, DropdownMenu, DropdownMenuItem, MessagesDefaultIcon } from '@bp/ui-components';
import classNames from 'classnames';
import { FragmentType, getFragmentData, graphql } from 'client/gql';
import { useAuthClaims } from 'hooks/useAuthClaims';
import { useTranslation } from 'react-i18next';
import { uniqueByUuid } from 'utils/uniquByUuid';
import { naturalStringSort } from '../../utils/stringHelper';
import styles from './LinkButtons.module.scss';

const MessageLinkButtonsFragment = graphql(`
  fragment MessageLinkButtonsFields on Query {
    groups(where: { uuid: $groupUuid }) {
      __typename
      uuid
      viewers {
        __typename
        uuid
        user {
          __typename
          uuid
          status
        }
        organizationRoles
        listName
      }
      editors {
        __typename
        uuid
          user {
              __typename
              status
          }
        organizationRoles
        listName
      }
    }
  }
`);

type MessageLinkButtonsProps = {
  onMessageAll: () => void;
  onMessage: (uuid: string, role: ProfileRoles) => void;
  query: FragmentType<typeof MessageLinkButtonsFragment> | undefined;
};

export const MessageLinkButtons = ({ onMessageAll, onMessage, query }: MessageLinkButtonsProps) => {
  const { t } = useTranslation();
  const { pimAuthClaims } = useAuthClaims();
  const profileUuid = pimAuthClaims.getProfile().uuid;

  const fragment = getFragmentData(MessageLinkButtonsFragment, query);

  const currentGroup = fragment?.groups[0];

  const viewers = currentGroup?.viewers ?? [];
  const editors = currentGroup?.editors ?? [];
  const members = [...viewers, ...editors];

  const receiverProfiles = uniqueByUuid(
    members.filter((profile) => {
      return (
        profile.uuid !== profileUuid &&
        (profile.user?.status === UserStatus.Full || profile.user?.status === UserStatus.ImpersonateOnly)
      );
    }),
  ).sort((a, b) => naturalStringSort(a.listName ?? '', b.listName ?? ''));

  const membersDropdown: DropdownMenuItem[] = receiverProfiles.map((m) => ({
    value: m.uuid,
    label: m.listName ?? '',
    onClick: () =>
      onMessage(
        m.uuid,
        (m.organizationRoles.find(
          (r) =>
            r === ProfileRoles.Teacher ||
            r === ProfileRoles.Student ||
            r === ProfileRoles.Parent ||
            r === ProfileRoles.Other,
        ) ?? ProfileRoles.Other) as ProfileRoles,
      ),
  }));

  return (
    <div className={classNames(styles['link-buttons'], styles['message-links'])}>
      {/*<div className={styles.button} onClick={onMessageAll}>*/}
      {/*  <div className={styles.icons}>*/}
      {/*    <MessagesDefaultIcon className={styles.icon} />*/}
      {/*    <MessagesDefaultIcon className={classNames(styles.icon, styles.duplicate)} />*/}
      {/*  </div>*/}
      {/*  <div className={styles.text}>{t('messages.newMessageForAll')}</div>*/}
      {/*</div>*/}
      <Dropdown
        disabled={members.length === 0}
        triggerClass={styles.trigger}
        maxHeight='m'
        trigger={
          <div className={styles.button}>
            <MessagesDefaultIcon className={styles.icon} />
            <div className={styles.text}>{t('messages.newMessage')}</div>
          </div>
        }
      >
        <DropdownMenu data={membersDropdown} />
      </Dropdown>
    </div>
  );
};
